export const privacy = "http://t.pia.jp/info/privacy.jsp";
export const terms = "https://pia-arena-mm.jp/about/ux/renga/terms?utm_source=renga&utm_medium=referral&utm_campaign=user";
export const official = "https://pia-arena-mm.jp/?utm_source=renga&utm_medium=referral&utm_campaign=user";
export const archives = "http://w.pia.jp/r/renga-archive/";
